<script setup>
import { useStore } from 'vuex'
import OverViewTableRow from '@/components/overview/OverviewTableRow.vue'
import SchematisationActionMenu from '@/components/schematisation/SchematisationActionMenu.vue'
import OverViewTableHeader from './OverviewTableHeader.vue'
import { actionMenuMixin } from '@/mixins/actionMenuMixin'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
const { x, y, showMenu, show } = actionMenuMixin()

const store = useStore()
const route = useRoute()
const router = useRouter()

const currentDikeSection = computed(() => store.state.dikeSection.currentItem)
const items = computed(() => store.state.stabSchematisation.items)
const currentOverviewSchematisation = computed(
  () => store.state.stabSchematisation.currentOverviewItem
)
const isDeleteSelf = computed(() => store.getters['stabSchematisation/isDeleteSelf'])
const currentProject = computed(() => store.state.project.currentProject)

const shownStabSchematisation = computed(() => {
  return items.value.filter(
    (stabSchematisation) => stabSchematisation.dikesection_id === currentDikeSection.value?.id
  )
})
const checkIfDeleteSelf = computed(() => {
  return isDeleteSelf.value(route)
})
const setCurrentSchematisation = (stabSchematisation) =>
  store.dispatch('stabSchematisation/setCurrentItem', stabSchematisation)
const setCurrentOverviewSchematisation = (stabSchematisation) =>
  store.dispatch('stabSchematisation/setCurrentOverviewItem', stabSchematisation)
const toggleDeleteDialog = () => store.dispatch('stabSchematisation/toggleDeleteDialog')
const toggleExportFactSheetsDialog = () =>
  store.dispatch('stabSchematisation/toggleExportFactSheetsDialog')
const toggleExportDStabilityDialog = () =>
  store.dispatch('stabSchematisation/toggleExportDStabilityDialog')
const toggleExportJsonDialog = () => store.dispatch('stabSchematisation/toggleExportJsonDialog')
const resetChildrenState = () => store.dispatch('stabSchematisation/resetChildrenState')
const setSelectedStabSchematisationStageId = (id) =>
  store.dispatch('dikeProfiles/setSelectedStabSchematisationStageId', id)

const navigateToSchematisation = async (stabSchematisation) => {
  if (stabSchematisation?.id !== currentOverviewSchematisation.value?.id) {
    await resetChildrenState()
  }
  await setCurrentOverviewSchematisation(stabSchematisation)
  await setCurrentSchematisation(stabSchematisation)
  await router.push({
    name: 'schematisation-stage',
    params: {
      id: currentProject.value.id,
      revisionId: stabSchematisation.stage_configuration_revision.id,
      schematisationId: stabSchematisation.id,
      schematisationStageId: stabSchematisation.first_not_done_schematisation_stage
    }
  })
}
</script>

<template>
  <div class="d-flex fill-height flex-column">
    <v-data-table
      :items="shownStabSchematisation"
      :items-per-page="-1"
      class="overflow-y-auto fill-height"
      density="compact"
      disable-sort
      hide-default-footer
      hover
    >
      <template #bottom></template>
      <template #headers></template>
      <template v-slot:thead>
        <OverViewTableHeader />
      </template>
      <template v-slot:item="{ item, index }">
        <OverViewTableRow
          :key="index"
          :item="item"
          @action="setSelectedStabSchematisationStageId($event)"
          @show="show($event)"
        ></OverViewTableRow>
      </template>
    </v-data-table>
    <SchematisationActionMenu
      @update:show-menu="showMenu = $event"
      :addButton="false"
      :duplicateButton="false"
      :show-menu="showMenu"
      :delete-disabled="checkIfDeleteSelf"
      :x="x"
      :y="y"
      @export="toggleExportFactSheetsDialog"
      @delete="toggleDeleteDialog"
      @exportDStab="toggleExportDStabilityDialog"
      @exportJson="toggleExportJsonDialog"
      @navigate="navigateToSchematisation(currentOverviewSchematisation)"
      @update="showMenu = false"
    ></SchematisationActionMenu>
  </div>
</template>
